import { Probe } from "@/pages/eaf/data-entry/models/eaf.models";
import { ManualAutoButton } from "@/shared/data-entries/ManualAutoButton";
import { ProcessCodeTag } from "@/shared/data-entries/ProcessCodeTag";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Probes",
      children: [
        {
          field: "actions",
          headerName: " ",
          flex: 1,
          minWidth: 45,
          cellRenderer: (params: ICellRendererParams<Probe>) => {
            if (!params.data) {
              return null;
            }

            const { ProcessCode, Order, IsProbeManual } = params.data;

            if (ProcessCode === "E") {
              return <ProcessCodeTag label="EAF" />;
            }

            if (ProcessCode === "L" && Order === 1) {
              return <ProcessCodeTag label="LAST" />;
            }

            return null;
          },
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params?.data?.Timestamp
              ? dxtToLocalServerTime(params.data.Timestamp, "HH:mm")
              : "",
        },
        {
          field: "Temperature",
          headerName: "Temp",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Temperature?.toFixed(0) || "0",
          flex: 2,
        },
        {
          field: "Oxygen",
          headerName: "O2",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Oxygen?.toFixed(1) || "0",
          flex: 2,
        },
        {
          field: "Carbon",
          headerName: "Carbon",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Carbon?.toFixed(3) || "0",
          flex: 2,
        },
      ],
    },
  ];

  return { columns };
};
